import React from "react";
import PropTypes from "prop-types";
import { Select } from "antd";

const Notify = ({ record }) => {
  console.log(record, "record");

  // const [NotifytModalData, setNotifyModalData] = useState({
  //     OrgName: "",
  //     PrimaryEmailAddr: "",
  //     PrimaryMobile: "",
  //     Subject: "",
  //     Message: "",
  //     SuperId: "",
  //   });

  // const fetchCompanyDetails = (record) => {
  //     setNotifyModalData({
  //       SuperId: record.SuperId || "",
  //       OrgName: record.OrgName || "",
  //       PrimaryEmailAddr: record.PrimaryEmailAddr || "",
  //       PrimaryMobile: record.PrimaryMobile || "",
  //       Subject: "Important Notification From Our Team",
  //       Message: `    Hi, ${record.OrgName}
  //                     We noticed that your attendance data has not been updated for the past few days.
  //                     To help us assist you better, we kindly request you to get in touch with our support
  //                     team at your earliest convenience.

  //                     Warm regards,
  //                     PerennialCode Support Team

  //                     Contact Us:
  //                     Phone: {8297230010}
  //                     Email: {support@perennialcode.in}`,
  //     });
  //   };

  // const sendWhatsAppNotification = async () => {
  //     if (!NotifytModalData.PrimaryMobile || !NotifytModalData.Message) {
  //       alert("Contact number and message are required!");
  //       return;
  //     }

  //     try {
  //       // WhatsApp Payload
  //       const whatsappPayload = {
  //         number: NotifytModalData.PrimaryMobile,
  //         client: NotifytModalData.OrgName,
  //         subject: NotifytModalData.Subject,
  //         message: NotifytModalData.Message,
  //       };

  //       // Mail Payload
  //       const mailPayload = {
  //         superid: NotifytModalData.SuperId,
  //         toaddr: NotifytModalData.PrimaryEmailAddr,
  //         message: NotifytModalData.Message,
  //         subject: NotifytModalData.Subject || "Test Message",
  //       };

  //       console.log(mailPayload, "mailpayload");

  //       // Send both APIs together
  //       const [whatsappRes, mailRes] = await Promise.all([
  //         axios.post(
  //           `${API_NOTIFY_URL}pcode/sendWhatsAppmessageHealthcheck`,
  //           whatsappPayload
  //         ),

  //         axios.post(
  //           "https://notify.ibizaccounts.com/api/notifyservice.php?action=sendmail",
  //           mailPayload
  //         ),
  //       ]);

  //       console.log("WhatsApp Response:", whatsappRes.data);
  //       console.log("Mail Response:", mailRes.data);

  //       if (whatsappRes.data.success || mailRes.data.success) {
  //         alert("WhatsApp and Mail sent successfully!");
  //       } else {
  //         alert("Failed to send notifications!");
  //       }
  //     } catch (err) {
  //       console.error(err);
  //       alert("Something went wrong!");
  //     }
  //   };

  // const handleChange = (e) => {
  //     setNotifyModalData({
  //       ...NotifytModalData,
  //       [e.target.name]: e.target.value,
  //     });
  //   };
  return (
    <div className="modal fade" id="Notification">
      <div className="modal-dialog modal-dialog-centered modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h3 className="text-gray-9 fw-medium">
              Send Notification To -{" "}
              <span
                style={{
                  color: "#FE9F43",
                  fontWeight: "700",
             
                  padding: "2px 8px",
                  
                }}
              >
                {record?.OrgName}
              </span>
            </h3>
            <button
              type="button"
              className="btn-close custom-btn-close p-0"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-md-3">
                <div className="mb-3">
                  <label className="fw-medium">Notification Template</label>

                  <Select
                    placeholder="Select Notification Template"
                    style={{ width: "100%" }}
                    // value={NotifytModalData.Template || undefined}
                    // onChange={(value) =>
                    //   setNotifytModalData({
                    //     ...NotifytModalData,
                    //     Template: value,
                    //   })
                    // }
                    options={[
                      { value: "welcome_template", label: "Welcome Template" },
                      { value: "password_reset", label: "Password Reset" },
                      {
                        value: "subscription_expiry",
                        label: "Subscription Expiry",
                      },
                      { value: "payment_success", label: "Payment Success" },
                      {
                        value: "maintenance_alert",
                        label: "Maintenance Alert",
                      },
                    ]}
                    getPopupContainer={(trigger) => trigger.parentNode}
                    popupClassName=""
                    dropdownStyle={{ zIndex: 9999 }}
                    dropdownRender={(menu) => (
                      <div style={{ zIndex: 9999, position: "relative" }}>
                        {menu}
                      </div>
                    )}
                  />
                </div>
              </div>

              <div className="col-md-3">
                <div className="mb-3">
                  <label className=" fw-medium">Subject</label>
                  <input
                    type="text"
                    className="form-control"
                    name="Subject"
                    // value={NotifytModalData.Subject}
                    // onChange={handleChange}
                  />
                </div>
              </div>

              <div className="col-md-3">
                <div className="mb-3">
                  <label className="fw-medium">Email To</label>
                  <input
                    type="email"
                    className="form-control"
                    name="PrimaryEmailAddr"
                    // value={NotifytModalData.PrimaryEmailAddr}
                    // onChange={handleChange}
                  />
                </div>
              </div>

              <div className="col-md-3">
                <div className="mb-3">
                  <label className="fw-medium">Contact</label>
                  <input
                    type="text"
                    className="form-control"
                    name="PrimaryMobile"
                    // value={NotifytModalData.PrimaryMobile}
                    // onChange={handleChange}
                  />
                </div>
              </div>

              <div className="col-md-8">
                <div className="mb-3">
                  <label className="fw-medium">Notify Message Content</label>
                  <textarea
                    className="form-control"
                    rows="5"
                    name="Message"
                    // value={NotifytModalData.Message}
                    // onChange={handleChange}
                  />
                </div>
              </div>

              <div className="text-center">
                <button
                  className="btn btn-success text-white"
                  //   onClick={sendWhatsAppNotification}
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Notify.propTypes = {
  record: PropTypes.shape({
    Id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    OrgName: PropTypes.string,
    SuperId: PropTypes.number,
  }),
};

export default Notify;
